// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ok-z","image":"Pk-z","lazyLoadPicture":"Qk-z","lazyLoadSpinner":"Rk-z","lazyLoadSpin":"Sk-z","lazyLoadImage":"Tk-z","hasStyledAspectRatio":"Uk-z"};